module.exports = __webpack_public_path__ + "img/dots_mobile_darkblue.6610b755.png";